import {connectRouter} from "connected-react-router";
import {combineReducers} from "redux";
import {i18nReducer} from "react-redux-i18n";

import contentReducer from "./content/reducers";
import circleCollectionReducer from "./circle_collection/reducers";
import circleSuggestionsReducer from "./circle_suggestion/reducers";
import home_ui from "./home_ui/reducers";
import circles_in_collection from "./circles_in_collection/reducers";
import circles from "./circles/reducers";
import users from "./users/reducers";
import iam from "./iam/reducers";
import ui_notifications from "./ui_notifications/reducers";
import member_requests from "./member_requests/reducers";
import my_circles from "./my_circles/reducers";
import commitments from "./commitment/reducers";
import bookings from "./booking/reducers";
import expenses from "./expenses/reducers";
import messaging from "./messaging/reducers";
import agreements from "./circle_agreement/reducers";
import app_notifications from "./app_notifications/reducers";
import usage_logs from "./usage_logs/reducers";
import b2b_button from "./b2b_button/reducers";
import prypool_products from "./prypool_products/reducers";
import rentable_circles from "./rentable_circles/reducers";

export default history =>
    combineReducers({
        router: connectRouter(history),
        content: contentReducer,
        i18n: i18nReducer,
        circle_collection: circleCollectionReducer,
        circle_suggestions: circleSuggestionsReducer,
        circles_in_collection: circles_in_collection,
        circles: circles,
        users: users,
        home_ui: home_ui,
        iam: iam,
        ui_notifications: ui_notifications,
        member_requests: member_requests,
        my_circles: my_circles,
        commitments: commitments,
        bookings: bookings,
        expenses: expenses,
        messaging: messaging,
        agreements: agreements,
        app_notifications: app_notifications,
        usage_logs: usage_logs,
        b2b_button: b2b_button,
        prypool_products: prypool_products,
        rentable_circles: rentable_circles
    });
